import React from 'react';

const BecomeVolunteer = () => {
  return (
    <section className="become-volunteer">
      <div className="container">
        <div className="row">
          <div className="col-xl-6 col-lg-6" data-aos="fade-right" data-aos-duration="2000" data-aos-delay="0">
            <div className="become-volunteer__single">
              <div className="become-volunteer__single-bg" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?auto=format&fit=crop&w=1400&q=60)' }}></div>
              <h3 className="become-volunteer__title"><a href="/about">Volunteer with Rayyan Aid</a></h3>
              <p className="become-volunteer__text">Give your time and skills to support education, healthcare and relief programs that change lives.</p>
              <div className="become-volunteer__btn-box">
                <a href="/about" className="thm-btn">
                  <span className="thm-btn-text">See More</span>
                  <span className="thm-btn-icon-box"><i className="fas fa-arrow-right"></i></span>
                </a>
              </div>
            </div>
          </div>
          <div className="col-xl-6 col-lg-6" data-aos="fade-left" data-aos-duration="2000" data-aos-delay="300">
            <div className="become-volunteer__single become-volunteer__single-2">
              <div className="become-volunteer__single-bg-2" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1526256262350-7da7584cf5eb?auto=format&fit=crop&w=1400&q=60)' }}></div>
              <h3 className="become-volunteer__title"><a href="/about">Become a Community Champion</a></h3>
              <p className="become-volunteer__text">From on‑the‑ground outreach to remote support, there are many ways to help families in need.</p>
              <div className="become-volunteer__btn-box-2">
                <a href="/about" className="thm-btn">
                  <span className="thm-btn-text">See More</span>
                  <span className="thm-btn-icon-box"><i className="fas fa-arrow-right"></i></span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BecomeVolunteer;
